import { useTheme } from '@emotion/react'
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react'


const useBreakpoints = () => {


    const Theme = useTheme()
    const isSm = useMediaQuery(Theme.breakpoints.down('sm'))
    const isMd = useMediaQuery(Theme.breakpoints.between('sm', 'md'));
    const isLg = useMediaQuery(Theme.breakpoints.up('md'));
    return { isSm, isMd, isLg }
}
export default useBreakpoints

